module.exports = __webpack_public_path__ + "static/assets/a14d50535c35ca787fa1aa944e51b39b.svg";